import React, { useEffect, useState } from "react";
import { DadosPessoaisEntidade, DependenteEntidade } from "@entidades";
import { DadosPessoaisService, DependenteService, FuncionalidadeService, LogService } from "@services";
import { LoadingComponent, MasterPage } from "@components";
import { Alert, Box, Col, Row, StaticField } from "@intech/web-ui";
import { DateFix } from "@helpers";
import { DMN_FUNCIONALIDADE } from "@domains";

export const DadosPessoais: React.FC = ({ ...rest }) => {

  const [DadosPessoais, setDadosPessoais] = useState<DadosPessoaisEntidade>(new DadosPessoaisEntidade());
  const [Dependentes, setDependentes] = useState<DependenteEntidade[]>([]);

  const [Bloqueio, setBloqueio] = useState<string>("");
  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const bloqueio = await FuncionalidadeService.BuscarBloqueiosPorNumFuncionalidade(DMN_FUNCIONALIDADE.DADOS_PESSOAIS, 1, 1, 1);
        setBloqueio(bloqueio);

        const dados = await DadosPessoaisService.Buscar();
        const dependentes = await DependenteService.Buscar();

        setDadosPessoais(dados);
        setDependentes(dependentes);

        await LogService.CriarLog(DMN_FUNCIONALIDADE.DADOS_PESSOAIS);
      } catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, []);

  // const AbrirAlteracaoCadastral = useCallback(() => {
  //   history.push("alteracaoCadastral");
  // }, [history]);

  return (
    <MasterPage {...rest}>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={"danger"}>{Erro}</Alert>}

      {!Loading && !Erro && Bloqueio && <Alert type={"danger"}>{Bloqueio}</Alert>}

      {!Loading && !Erro && !Bloqueio && !DadosPessoais && (!Dependentes || Dependentes.length === 0) && <Alert type={"info"}>{"Nenhuma informação disponível no momento."}</Alert>}

      {!Loading && !Erro && !Bloqueio && DadosPessoais && <>
        <Row>
          <Col>
            <Box title={"Dados Pessoais"}>
              <Row>
                <Col>
                  <StaticField
                    title={"Nome"}
                    value={DadosPessoais.NO_PESSOA}
                    labelPosition={"up"}
                  />
                </Col>

                <Col>
                  <StaticField
                    title={"Sexo"}
                    value={DadosPessoais.DS_SEXO}
                    labelPosition={"up"}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <StaticField
                    title={"Data de nascimento"}
                    value={DateFix(DadosPessoais.DT_NASCIMENTO)}
                    labelPosition={"up"}
                  />
                </Col>

                <Col>
                  <StaticField
                    title={"CPF"}
                    value={DadosPessoais.NR_CPF}
                    labelPosition={"up"}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <StaticField
                    title={"Estado Civil"}
                    value={DadosPessoais.DS_ESTADO_CIVIL}
                    labelPosition={"up"}
                  />
                </Col>

                <Col>
                  <StaticField
                    title={"Grau de Instrução"}
                    value={DadosPessoais.DS_GRAU_INSTRUCAO}
                    labelPosition={"up"}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <StaticField
                    title={"Nome da Mãe"}
                    value={DadosPessoais.NO_MAE}
                    labelPosition={"up"}
                  />
                </Col>

                <Col>
                  <StaticField
                    title={"Nome do Pai"}
                    value={DadosPessoais.NO_PAI}
                    labelPosition={"up"}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <StaticField
                    title={"Nacionalidade"}
                    value={DadosPessoais.NO_PAIS_NACIONALIDADE}
                    labelPosition={"up"}
                  />
                </Col>

                <Col>
                  <StaticField
                    title={"Naturalidade"}
                    value={DadosPessoais.NO_NATURALIDADE}
                    labelPosition={"up"}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <StaticField
                    title={"E-mail"}
                    value={DadosPessoais.NO_EMAIL}
                    labelPosition={"up"}
                  />
                </Col>

                <Col>
                  <StaticField
                    title={"Celular"}
                    value={DadosPessoais.NR_CELULAR}
                    labelPosition={"up"}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <StaticField
                    title={"Politicamente Exposto"}
                    value={DadosPessoais.EE_POLITICAMENTE_EXPOSTO}
                    labelPosition={"up"}
                  />
                </Col>

                <Col>
                  <StaticField
                    title={"FATCA - US Person"}
                    value={DadosPessoais.EE_US_PERSON}
                    labelPosition={"up"}
                  />
                </Col>
              </Row>
            </Box>
          </Col>

          <Col>
            {DadosPessoais.NO_EMPRESA && (
              <Box title={"Dados Funcionais"}>
                <Row>
                  <Col>
                    <StaticField
                      title={"Empresa"}
                      value={DadosPessoais.NO_EMPRESA}
                      labelPosition={"up"}
                    />
                  </Col>

                  <Col>
                    <StaticField
                      title={"Data de Admissão"}
                      value={DateFix(DadosPessoais.DT_ADMISSAO)}
                      labelPosition={"up"}
                    />
                  </Col>

                  <Col>
                    <StaticField
                      title={"Matrícula"}
                      value={DadosPessoais.NR_REGISTRO}
                      labelPosition={"up"}
                    />
                  </Col>
                </Row>
              </Box>
            )}

            {DadosPessoais.CD_BANCO && (
              <Box title={"Dados Bancários"}>
                <Row>
                  <Col>
                    <StaticField
                      title={"Banco"}
                      value={DadosPessoais.CD_BANCO + "-" + DadosPessoais.NO_BANCO}
                      labelPosition={"up"}
                    />
                  </Col>

                  <Col>
                    <StaticField
                      title={"Agência"}
                      value={DadosPessoais.CD_AGENCIA + "-" + DadosPessoais.DV_AGENCIA}
                      labelPosition={"up"}
                    />
                  </Col>

                  <Col>
                    <StaticField
                      title={"Conta"}
                      value={DadosPessoais.NR_CC + "-" + DadosPessoais.DV_CC}
                      labelPosition={"up"}
                    />
                  </Col>
                </Row>
              </Box>
            )}

            <Box title={"Endereço"}>
              <Row>
                <Col>
                  <StaticField
                    title={"Endereço"}
                    value={DadosPessoais.DS_ENDERECO}
                    labelPosition={"up"}
                  />
                </Col>

                <Col>
                  <StaticField
                    title={"Número"}
                    value={DadosPessoais.NR_ENDERECO}
                    labelPosition={"up"}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <StaticField
                    title={"Complemento"}
                    value={DadosPessoais.DS_COMPLEMENTO}
                    labelPosition={"up"}
                  />
                </Col>

                <Col>
                  <StaticField
                    title={"Bairro"}
                    value={DadosPessoais.NO_BAIRRO}
                    labelPosition={"up"}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <StaticField
                    title={"Cidade"}
                    value={DadosPessoais.DS_MUNICIPIO}
                    fieldSize={4}
                    labelPosition={"up"}
                  />
                </Col>

                <Col>
                  <StaticField
                    title={"UF"}
                    value={DadosPessoais.CD_UF}
                    fieldSize={2}
                    labelPosition={"up"}
                  />
                </Col>

                <Col>
                  <StaticField
                    title={"CEP"}
                    value={DadosPessoais.NR_CEP}
                    labelPosition={"up"}
                  />
                </Col>
              </Row>
            </Box>
          </Col>
        </Row>

        <Row>
          <Col>
            <Box title={"Dependentes"}>
              {Dependentes.length > 0 &&
                <table className={"table table-striped table-sm"}>
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Data de Nascimento</th>
                      <th>Grau de Parentesco</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Dependentes.map(
                      (dependente: any, index: number) => {
                        return (
                          <tr key={index}>
                            <td>{dependente.NO_PESSOA}</td>
                            <td>{DateFix(dependente.DT_NASCIMENTO)}</td>
                            <td>{dependente.DS_GRAU_PARENTESCO}</td>
                          </tr>
                        );
                      }
                    )}
                  </tbody>
                </table>}

              {Dependentes.length === 0 && <Alert type={"info"}>{"Não há dependentes cadastrados"}</Alert>}
            </Box>
          </Col>
        </Row>

        {/* <Row>
          <Col>
            <Button
              onClick={AbrirAlteracaoCadastral}
              title={"Alterar Dados Cadastrais"}
              type={"primary"}
              icon={<FaAddressCard />}
            />
          </Col>
        </Row> */}
      </>}
    </MasterPage>
  );
}
